import { getOrigin, getMailPath } from 'owa-url';
import loc from 'owa-localize';
import { mailtoProtocolHandlerTitle } from 'owa-locstrings/lib/strings/pwa.locstring.json';

export default function initializeProtocolHandlers() {
    if (window?.navigator?.registerProtocolHandler) {
        window.navigator.registerProtocolHandler(
            'mailto',
            `${getOrigin()}${getMailPath()}deeplink/compose?mailtouri=%s`,
            loc(mailtoProtocolHandlerTitle)
        );
    }
}
